<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-user-graduate mr-1"></i> Professores
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container">
            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Nome">
                        <b-form-input
                            v-model="filter.name"
                            placeholder="Buscar por nome ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Email">
                        <b-form-input
                            v-model="filter.email"
                            placeholder="Buscar por email ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Telefone">
                        <b-form-input
                            v-model="filter.phone"
                            placeholder="Buscar por telefone ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <b-card class="mb-4">
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                    <!-- Loading -->
                    <template #loading>
                        <b-skeleton-table
                            :rows="lastResultsCount"
                            :columns="6"
                            :table-props="{ bordered: true, striped: true }"
                        >
                        </b-skeleton-table>
                    </template>

                    <!-- Table -->
                    <b-table
                        id="teachersTable"
                        :items="table"
                        :fields="fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="changeSortable"
                        empty-text="Não encontramos nenhum resultado na busca :("
                        class="bg-white mb-0"
                        stacked="md"
                        :sticky-header="true"
                        show-empty
                        no-local-sorting
                        bordered
                        hover>

                        <template v-slot:cell(name)="row">
                            <span v-if="row.item.name" v-b-tooltip.hover :title="row.item.name">
                                {{ row.item.name | truncate(20)}}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(email)="row">
                            <span v-if="row.item.email" v-b-tooltip.hover :title="row.item.email">
                                {{ row.item.email | truncate(20)}}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(phone)="row">
                            <span v-if="row.item.phone" v-b-tooltip.hover :title="row.item.phone">
                                {{ row.item.phone | truncate(20)}}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(phone)="row">
                            <span v-if="row.item.phone">
                                {{ row.item.phone }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(trial_end)="row">
                            <span v-if="row.item.trial_end">
                                <span v-if="$moment().isAfter(row.item.trial_end)" class="text-danger" v-b-tooltip.hover :title="row.item.trial_end | moment('DD/MM/YYYY HH:mm')">
                                    Acabou {{ row.item.trial_end | moment('from', 'now') }}
                                </span>
                                <span v-else class="text-success" v-b-tooltip.hover :title="row.item.trial_end | moment('DD/MM/YYYY HH:mm')">
                                    Termina {{ row.item.trial_end | moment('from', 'now') }}
                                </span>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(created_at)="row">
                            <span v-b-tooltip.hover :title="row.item.created_at | moment('DD/MM/YYYY HH:mm')">
                                {{ row.item.created_at | moment('from', 'now') }}
                            </span>
                        </template>

                        <template v-slot:cell(actions)="row">

                            <div class="text-center">

                                <!-- Details -->
                                <a href="#" class="mr-2" @click="showDetails(row.item)" v-b-tooltip.hover title="Detalhes do Professor">
                                    <i class="fas fa-eye"></i>
                                </a>

                            </div>

                        </template>

                    </b-table>
                </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <!-- Results -->
            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>
        </div>

        <!-- Show -->
        <show></show>

        <!-- Change Due Date -->
        <change-due-date @updated="load"></change-due-date>

    </div>
</template>

<script>
import Show from './Show'
import ChangeDueDate from "./ChangeDueDate";

export default {
    components: {
        Show,
        ChangeDueDate
    },
    props: [],
    data() {
        return {
            loading: false,
            table: [],
            perPage: 12,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [
                { key: 'name', label: 'Nome', sortable: true},
                { key: 'email', label: 'Email', sortable: true},
                { key: 'phone', label: 'Telefone', sortable: true},
                { key: 'trial_end', label: 'Período de Testes'},
                { key: 'created_at', label: 'Entrou', sortable: true },
                { key: 'actions', label: '' }
            ],
            filter: {
                name: null,
                email: null,
                phone: null,
            },
            lastResultsCount: 5,
            premium: null,
            premiumOptions: [
                {
                    id: 'only_premium',
                    name: 'Somente Premium'
                },
                {
                    id: 'no_premium',
                    name: 'Somente Não Premium'
                },
            ]
        }
    },
    created() {
        this.load()
    },
    watch: {
        'filter.name': async function (value) {
            this.filter.name = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.email': async function (value) {
            this.filter.email = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.phone': async function (value) {
            this.filter.phone = await value;
            this.currentPage = 1
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/admin/teachers', {
                params: {
                    name: this.filter.name,
                    email: this.filter.email,
                    phone: this.filter.phone,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.teachers.data
                    this.currentPage = response.teachers.current_page
                    this.perPage = response.teachers.per_page
                    this.total = response.teachers.total

                    this.lastResultsCount = response.teachers.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        showDetails(teacher) {
            this.$root.$emit('teachersShowDetail', teacher);
        },

        changeDueDate(teacher) {
            this.$root.$emit('changeDueDate', teacher);
        },

        nextDueDate(teacher) {
            this.$bvModal.msgBoxConfirm('Deseja realmente marcar como paga e gerar a próxima ?', {
                cancelTitle: 'Cancelar',
                okTitle: 'Paga e Gerar Próxima',
                cancelVariant: 'default',
                okVariant: 'primary'
            }).then(answer => {
                if (answer) {
                    this.loading = true;
                    axios.put('/admin/teachers/' + teacher.id + '/next-due-date')
                        .then((result) => {

                            // Message
                            this.$toast.success('Data de vencimento alterada com sucesso :)');

                            // Load
                            this.load()

                        })
                        .finally(() => this.loading = false)
                }
            })
        }

    }
}
</script>

<style scoped>
</style>
